// extracted by mini-css-extract-plugin
export default {"expand":"KopiujLega_expand__iyj4V"};